
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { COUNTRIES } from "@/utils/country-list";
import { Control } from "react-hook-form";
import { LocationFormValues } from "./types";

type CountryFieldProps = {
  control: Control<LocationFormValues>;
};

const CountryField = ({ control }: CountryFieldProps) => {
  if (!control) {
    console.error("Form control is missing in CountryField");
    return null;
  }
  
  return (
    <FormField
      control={control}
      name="country"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Country</FormLabel>
          <FormControl>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
              value={field.value}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select your country" />
              </SelectTrigger>
              <SelectContent>
                {COUNTRIES.map((country) => (
                  <SelectItem key={country.value} value={country.label}>
                    {country.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormDescription>
            Your country determines which consumer protection laws apply to your refund requests.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default CountryField;
